// ** Custom Components
import Block from "components/layout/Block";
import Text from "components/typography/Text";

const StepLabel = ({ label }) => {
	return (
		<Block flex alignCenter mb={5} mt={1}>
			<Text
				bold
				color={"black"}
				size="1.25rem"
				m0auto
				style={{
					textShadow: "none",
					color: "var(--dz-comp-auth-panel-text-color)",
				}}
			>
				{label}
			</Text>
		</Block>
	);
};

export default StepLabel;
